'use client';

import { Text, Container, useTranslation } from '@weareconceptstudio/core';
import { ProductItem } from '@weareconceptstudio/ecommerce/v1';
import { config } from '@/helpers';
import { useMostWanted } from '@/libs/hooks';

//* Styles
import BestSellersStyle from './style';

//* Component
import Button from '@/components/Button';

const BestSellers = () => {
	const { selectedLang } = useTranslation();

	const { data } = useMostWanted({ selectedLang });

	return data?.length > 0 ? (
		<BestSellersStyle>
			<Container isSection>
				<div className='title-button-wrapper'>
					<Text
						tag={'h2'}
						text={'bestTitle'}
						className={'title h2 uppercase'}
					/>

					<Button
						text={'orderNow'}
						url={config.routes.menu.path}
					/>
				</div>

				<div className='wrapper-bestseller'>
					{data.slice(0, 4).map((item, i) => (
						<ProductItem
							key={i}
							{...item}
							image={item.thumbnail || item.image}
						/>
					))}
				</div>
			</Container>
		</BestSellersStyle>
	) : null;
};

export default BestSellers;
